import React, { useState } from 'react';
import type { ReactNode } from 'react';
import { useEnrollment } from '../context';
import {
  Container,
  Content,
  Title,
  Subtitle,
  FlowIndicator,
  FlowRow,
  EbanxLogo,
  FlowText,
  ArrowDown,
  BankLogo,
  BankLogoPlaceholder,
} from './bank-redirect-screen.styles';

export function BankRedirectScreen(): ReactNode {
  const { data } = useEnrollment();
  const [logoError, setLogoError] = useState(false);

  return (
    <Container>
      <Content>
        <Title>Redirecionamento bancário</Title>
        <Subtitle>
          Você esta sendo redirecionado com segurança para confirmar a operação via Open Finance.
        </Subtitle>

        <FlowIndicator>
          <FlowRow>
            <EbanxLogo>
              <EbanxLogoSvg />
            </EbanxLogo>
            <FlowText>EBANX</FlowText>
          </FlowRow>

          <ArrowDown>
            <ArrowSvg />
          </ArrowDown>

          <FlowRow>
            {data.bankLogoUrl && !logoError ? (
              <BankLogo src={data.bankLogoUrl} alt={data.bankName} onError={() => setLogoError(true)} />
            ) : (
              <BankLogoPlaceholder>{data.bankName.charAt(0)}</BankLogoPlaceholder>
            )}
            <FlowText>{data.bankName}</FlowText>
          </FlowRow>
        </FlowIndicator>
      </Content>
    </Container>
  );
}

function EbanxLogoSvg(): ReactNode {
  return (
    <svg width="44" height="14" viewBox="0 0 44 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="0" y="12" fontSize="12" fontWeight="bold" fill="#1b1464" fontFamily="sans-serif">EBANX</text>
    </svg>
  );
}

function ArrowSvg(): ReactNode {
  return (
    <svg width="24" height="40" viewBox="0 0 24 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0V32M12 32L6 26M12 32L18 26" stroke="#afb8ca" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
